export default "__VITE_ASSET__DcY3JaAJ__"